/* globals GTM_CODE */
import "@/styles/fonts.scss";
import "~/scss/styles.scss";
import Vue from "vue";
import VueGtm from "vue-gtm";
import * as VueGoogleMaps from "vue2-google-maps"; // eslint-disable-line import/no-extraneous-dependencies
import VueCookies from "vue-cookies";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { CaptureConsole as CaptureConsoleIntegration, Dedupe as DedupeIntegration } from "@sentry/integrations";

import App from "./MyHomeApp";
import store from "./store/store";
import router from "./myhome-router";
import conf from "./appConf";

if (process.env.NODE_ENV === "production")
  Sentry.init({
    Vue,
    dsn: conf.sentryDSN,
    release: `dea-myhome@${process.env.npm_package_version}`,
    debug: process.env.NODE_ENV !== "production",
    environment: process.env.NODE_ENV,
    autoSessionTracking: true,
    denyUrls: ["local.deascuola.it"],
    integrations: [
      new Integrations.BrowserTracing(),
      new CaptureConsoleIntegration({ levels: ["error", "debug", "assert"] }),
      new DedupeIntegration(),
    ],
    tracesSampleRate: 2.0,
  });

Vue.use(VueCookies);

Vue.use(VueGoogleMaps, {
  load: {
    key: conf.googleKey,
    libraries: "places",
  },
  installComponents: true,
});

if (GTM_CODE) {
  Vue.use(VueGtm, {
    id: GTM_CODE,
    enabled: true,
    debug: true,
    loadScript: true,
    vueRouter: router,
  });
}
// eslint-disable-next-line no-new
new Vue({
  el: "#myhome",
  store,
  data: {
    config: conf,
    asyncConf: {},
    data: {},
    autosuggestData: { queries: [], links: [] },
    user: { targetClasses: {} },
  },
  render: h => h(App),
  router,
});
